import { format } from "date-fns";
import PropTypes from "prop-types";
// External components
import { Card, Typography, Tooltip } from "@mui/material";
// Utils
import { formatCurrency } from "../../utils";
// Styles
import "./CreditDebitCard.scss";
import useCoinDetails from "../../hooks/useCoinDetails";

function CreditDebitCard({ note, onClick }) {
  const { toLocalExchangeRate } = useCoinDetails();
  const item = {
    Key: note?.Key,
    Coin: {
      Code_Coin: note?.Coin?.Code_Coin,
      Name_Coin: note?.Coin?.Name_Coin,
    },
    TotalBill: toLocalExchangeRate(note?.TotalSell, note?.Coin),
    EmitedDay: note?.EmitedDay,
  };
  return (
    <Card
      color="primary"
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "start",
        gap: "0.1rem",
        height: "189px",
        width: { xs: "100%", sm: "90%" },
        padding: "1rem",
      }}
      onClick={onClick}
    >
      <Typography
        align="start"
        sx={{
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          width: { xs: "200px", sm: "20vw" },
          height: "100%",
        }}
        typography="modeColor"
        variant="subtitle1"
      >
        <span
          className="has-text-weight-bold"
          style={{ marginRight: "0.75rem" }}
          title={item?.Key}
        >
          Key:
        </span>
        <Tooltip arrow title={item?.Key}>
          <span>{item?.Key?.substring(0, 15)}...</span>
        </Tooltip>
      </Typography>
      <Typography align="start" typography="modeColor" variant="subtitle1">
        <span className="has-text-weight-bold" style={{ marginRight: "1rem" }}>
          Moneda:
        </span>
        {item?.Coin?.Name_Coin}
      </Typography>
      <Typography align="start" typography="modeColor" variant="subtitle1">
        <span className="has-text-weight-bold" style={{ marginRight: "1rem" }}>
          Total:
        </span>
        {formatCurrency(
          parseFloat(item.TotalBill, 10),
          item?.Coin?.Code_Coin ? item?.Coin?.Code_Coin : "CRC",
        )}
      </Typography>
      {item?.EmitedDay && (
        <Typography align="start" typography="modeColor" variant="subtitle1">
          <span
            className="has-text-weight-bold"
            style={{ marginRight: "0.5rem" }}
          >
            &nbsp; Fecha:&nbsp;
          </span>
          &nbsp;
          {item.EmitedDay
            ? format(new Date(item.EmitedDay), "dd/MM/yyyy")
            : "sin fecha"}
        </Typography>
      )}
    </Card>
  );
}

CreditDebitCard.propTypes = {
  onClick: PropTypes.func,
  note: PropTypes.object,
};
CreditDebitCard.defaultProps = {
  onClick: () => {},
  note: {},
};

export default CreditDebitCard;
